import type { SiteResponse } from "@/client/types.gen";
import "./ShopCard.css";

export default function ShopCard(shop: SiteResponse) {
  const content = (
    <div className="shop-card">
      {shop.name && (
        <>
          <h3 className="shop-card-name">{shop.name}</h3>
          {/* {isNew && <span className="shop-card-badge">NEW</span>} */}
          {/* {displayLocation && <p className="shop-card-location">{displayLocation}</p>} */}
        </>
      )}
    </div>
  );

  return shop.base_url ? <a href={shop.base_url}>{content}</a> : content;
}
